import {
  AdminService,
  AgentSessionManager,
} from '@nice-ccf/core-sdk';
import { CallContact } from '../model/call-contact';
import { VoiceContact } from './voice-contact';
import { Subject } from 'rxjs/internal/Subject';
import { VoiceService } from '../service/voice-service';
import { ContactService } from '../service/contact-service';
import { ContactType } from '../enum/contact-type';
import { CXoneContact } from '../model/cxone-contact';

/**
 * Class to handle the contacts
 */
export class ContactManager {
  private agentSession = <AgentSessionManager>{};
  private adminService = <AdminService>{};
  public voiceContactUpdateEvent: Subject<CallContact> = new Subject();
  public voiceService = <VoiceService>{};
  public contactService = <ContactService>{};
  public voiceContact = <VoiceContact>{};

  /**
   * @example
   * ```
   * const contactManager = new ContactManager();
   * ```
   */
  constructor() {
    this.agentSession = AgentSessionManager.instance;
    this.adminService = AdminService.instance;
    this.initialize();
  }

  /**
   * Method to create instance for voice and contact service and update agent permissions event
   */
  private initialize() {
    this.voiceService = new VoiceService();
    this.contactService = new ContactService();
    this.voiceContact = new VoiceContact();
    this.voiceContact.initialize(this.handleContact);
    this.updatePermissionsEventHandler();
  }

  /**
   * subscribe the update agent permissions event
   */
  private updatePermissionsEventHandler() {
    this.agentSession.updatePermissionsEventSubject.subscribe(() => {
      this.adminService.getPermissions(true).then(() => {
        this.voiceContact.updateAgentPreference();
      });
    });
  }

  /**
   * Method used to get the CXoneContact
   */
  private handleContact = (contact: CXoneContact) => {
    switch (contact.type) {
      case ContactType.VOICE_CONTACT:
        this.voiceContactUpdateEvent.next(contact as CallContact);
        break;
    }
  };
}
